// src/mixpanel.js
import { jwtDecode } from "jwt-decode";
import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
const env = import.meta.env.VITE_ENV;

export const setMixpanelEnv = (env: string) => {
  mixpanel.register({ env });
};

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    api_host: "https://api-eu.mixpanel.com",
    debug: false, // enable debug log in console
    // track_pageview: "full-url",
    persistence: "localStorage", // or 'cookie'
  });
  setMixpanelEnv(env);
}

// export const trackUserConnection = () => {
//   if (!localStorage.getItem("mixpanel_connected")) {
//     mixpanel.track("User Connected");
//     localStorage.setItem("mixpanel_connected", "true");
//   }
// };

export const setMixpanelUserId = (token: string) => {
  const decoded: { userId: string } = jwtDecode(token);
  const userId = decoded.userId;
  mixpanel.alias(userId);
  mixpanel.identify(userId);
  mixpanel.track("Log In");
};

export const resetMixpanel = () => {
  mixpanel.track("Log Out");
  mixpanel.reset();
};

export function initUTMTracking() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  const utmData: Record<string, string> = {};

  utmParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      utmData[param] = value;
    }
  });

  // Save to localStorage or cookie for persistence
  // if (Object.keys(utmData).length > 0) {
  //   localStorage.setItem("utm_data", JSON.stringify(utmData));
  // }

  // Register as super properties
  mixpanel.register(utmData); // ← this attaches to all future track/identify calls
}

export default mixpanel;
